import * as go from 'gojs';
import theme from 'theme/theme';
import { PanelNames } from './panelNames';
import type { BaseNodeData } from 'gojs/types';

const $ = go.GraphObject.make;

export const getSelectionAdornment = () => ({
  selectionObjectName: PanelNames.UNIT_NODE_SELECTION_SHAPE,
  locationObjectName: PanelNames.UNIT_NODE_SELECTION_SHAPE,
  locationSpot: go.Spot.Center,
  selectionAdornmentTemplate: $(go.Adornment),
});

export const selectionColorBinding = () =>
  new go.Binding('fill', '', (data: BaseNodeData) => {
    return data.selected || data.active
      ? `${theme.palette.info.light}80`
      : 'transparent';
  });

export const selectionBorderBinding = () =>
  new go.Binding('stroke', '', (data: BaseNodeData) => {
    return data.selected || data.active
      ? theme.palette.info.main
      : 'transparent';
  });
